import { useRef, useState } from 'react';
import { Form } from 'src/utils/form';

function useFormAdapter(schema, formName = 'form') {
  const [, setTick] = useState(0);

  const componentRef = useRef(null);
  if (!componentRef.current) {
    componentRef.current = {
      state: {},
      setState: (updater) => {
        const prev = componentRef.current.state;
        const nextPartial =
          typeof updater === 'function' ? updater(prev) : updater;
        componentRef.current.state = {
          ...prev,
          ...nextPartial,
        };
        setTick((t) => t + 1);
      },
    };
  }

  const formRef = useRef(null);
  if (!formRef.current) {
    formRef.current = new Form({
      component: componentRef.current,
      name: formName,
      schema,
    });
  }

  return formRef.current;
}

export default useFormAdapter;
